import React, { useState } from "react";
import Select from "react-select";
import { DatePicker } from "rsuite";

import PageTitle from "../../layouts/PageTitle";
import { useNavigate } from "react-router-dom";

const options = [
  { value: "1", label: "Gender" },
  { value: "2", label: "Male" },
  { value: "3", label: "Female" },
];

const options1 = [
  { value: "1", label: "Department" },
  { value: "2", label: "React" },
  { value: "3", label: "CSS" },
  { value: "4", label: "JavaScript" },
  { value: "4", label: "Angular" },
  { value: "4", label: "HTML" },
  { value: "4", label: "VueJs" },
  { value: "4", label: "Ruby" },
  { value: "4", label: "PHP" },
  { value: "4", label: "ASP.NET" },
  { value: "4", label: "Python" },
  { value: "4", label: "MySQL" },
];

const AddTeam = () => {
  const navigate = useNavigate();

  function handleSave(e) {
    e.preventDefault();
    const submissionData = { ...formData, paymentStatus: "Unpaid" };
    navigate("/admin/about-student", { state: { data: submissionData } });
  }

  const [formData, setFormData] = useState({
    studentName: "",
    dob: null,
    age: "",
    sex: "",
    package: "",
    address: "",
    mobileNumber: "",
    schoolName: "",
    batting: "",
    bowling: "",
    wicketKeeping: "",
    clubMember: "",
    parentName: "",
    joiningDate: null,
    amountDeposited: "",
    selectedPackage: "",
    receiptNo: "",
    parentSignature: null,
    studentSignature: null,
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSelectChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const { id, files } = e.target;
    setFormData({ ...formData, [id]: files[0] });
  };
  return (
    <>
      <PageTitle activeMenu={"Add Team"} motherMenu={"Teams"} />
      <div className="row">
        <div className="col-xl-12 col-xxl-12 col-sm-12">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                Whitefield Cricket Academy Team Registration
              </h5>
            </div>
            <div className="card-body">
              <form>
                <div className="row">
                  {/* Tournament Name */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="tournamentName">
                        Name
                      </label>
                      <input
                        id="tournamentName"
                        placeholder="Enter Tournament or Practice Name"
                        type="text"
                        className="form-control"
                        required
                      />
                    </div>
                  </div>

                  {/* Ball Type */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label">Tournament</label>
                      <Select
                        isSearchable={false}
                        options={[
                          { value: "1", label: "Practice Match" },
                          { value: "2", label: "Interclub Tournament" },
                          { value: "3", label: "City League Finals" },
                        ]}
                        placeholder="Select Tournament"
                        className="custom-react-select"
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="matchDate">
                        Schedule Date
                      </label>
                      <div className="input-hasicon mb-xl-0 mb-3">
                        <DatePicker
                          placeholder="Select Schedule Date"
                          className="picker-suit"
                        />
                        <div className="icon">
                          <i className="far fa-calendar" />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Submit / Cancel */}
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <button
                      type="submit"
                      className="btn btn-primary me-1"
                      onClick={handleSave}
                    >
                      Submit
                    </button>
                    <button type="reset" className="btn btn-danger light">
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTeam;
